// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import FilterFilled from '../_raw/ui/icon_filter_filled.svg';
import withIconProps from '../withIconProps';

export default withIconProps(FilterFilled);
